import { gql } from '@apollo/client';

export const GET_DEVOULUTION_PAGE_CONFIGS = gql`
  query GetDevolutionPageConfigs($storeId: ID!) {
    getDevolutionPageConfigs(storeId: $storeId) {
      __typename
      ... on GetDevolutionPageConfigsSuccess {
        code
        configs {
          storeId
          backgroundColor
          headerFooterColor
          primaryColor
          secondaryColor
          fontColor
          fontColorSecondary
          footerIconsColor
          fontFamily
          logoUrl
          faviconUrl
          mainImageUrl
          mainImageMobileUrl
          instagramAccount
          facebookAccount
          linkedinAccount
          tiktokAccount
          contactEmail
          link1Title
          link1Url
          link2Title
          link2Url
          mainImageSizingMode
          mainImageMobileSizingMode
          publicPageEndpoint
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
